import React from "react";
import NewMonsterForm from "../components/NewMonsterForm";

const NewMonsterPage = () => {
  return <NewMonsterForm />;
};

export default NewMonsterPage;
